import { IRequestContext } from '@msdyn365-commerce/core-internal';
import { ITelemetry } from '@msdyn365-commerce/telemetry-internal';
import { useMemo } from 'react';
import { RelewiseRecommendationService } from '../services/RecommendationService';
import { RelewiseTrackingService } from '../services/TrackingService';
import { RelewiseMappingService } from '../services/MappingService';
import { RelewiseSearchService } from '../services/SearchService';
import { RelewiseCategoryService } from '../services/CategoryService';
import { RelewiseProductService } from '../services/ProductService';

export const useTrackingService = (request: IRequestContext, telemetry: ITelemetry) => {
    const relewiseTrackingService = useMemo(() => new RelewiseTrackingService(request, telemetry), [request, telemetry]);
    return relewiseTrackingService;
};

export const useMappingService = (request: IRequestContext, telemetry: ITelemetry) => {
    const mappingService = useMemo(() => new RelewiseMappingService(request, telemetry), [request, telemetry]);
    return mappingService;
};

export const useRecommendationService = (request: IRequestContext, telemetry: ITelemetry) => {
    const recommendationService = useMemo(() => new RelewiseRecommendationService(request, telemetry), [request, telemetry]);
    return recommendationService;
};

export const useCategoryService = (request: IRequestContext, telemetry: ITelemetry) => {
    const categoryService = useMemo(() => new RelewiseCategoryService(request, telemetry), [request, telemetry]);
    return categoryService;
};

export const useSearchService = (request: IRequestContext, telemetry: ITelemetry) => {
    const searchService = useMemo(() => new RelewiseSearchService(request, telemetry), [request, telemetry]);
    return searchService;
};

export const useProductService = (request: IRequestContext, telemetry: ITelemetry) => {
    const productService = useMemo(() => new RelewiseProductService(request, telemetry), [request, telemetry]);
    return productService;
};
